import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { ORDERS_ROUTE } from '../shared/constants/routes';
import { OrdersComponent } from './orders/orders.component';
import { AuthGuard } from '../guards/auth.guard';

const routes: Routes = [
  {
    path: ORDERS_ROUTE,
    component: OrdersComponent,
    canActivate: [AuthGuard],
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class OrdersRoutingModule {}
